export default __webpack_public_path__ + "static/media/banner-top.cdbb49e2.jpg";